export default function (theme) {
    return {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    whiteSpace: 'normal',
                    overflow: 'auto'
                },
            }
        }
    };
}